//Reference: EN052

import { Mappeable } from './mappeable.model';
import * as _ from 'lodash';
import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';

export class Question extends Mappeable {
        
    idQuestionTypePk: number;
    //CODE: string;
    txtQuestion: string;
    optionQuestion: boolean;
    textQuestion: boolean;
    typeQuestion: any;
    nmrOrder: number;
    isQuestionEvaluated: boolean;
    isQuestionEvaluatedMapped: any;
    dateInsert: string;
    dateUpdate: string;
    userInsert: string;
    userUpdate: string;

    constructor(o,translateService = null) {
        super(o);       
        this.typeQuestion = this.optionQuestion ?
            {
                name: translateService ? translateService.instant("ADMINISTRATION.SURVEY_QUESTION.COMMON.QUESTION_TYPE.CHOOSE") : '-',
                value: true
            } : {
                name: translateService ? translateService.instant("ADMINISTRATION.SURVEY_QUESTION.COMMON.QUESTION_TYPE.TEXT") : '-',
                value: false
            };
        this.isQuestionEvaluatedMapped = this.isQuestionEvaluated ?
            {
                name: translateService ? translateService.instant("ADMINISTRATION.SURVEY_QUESTION.COMMON.EVALUATED") : '-',
                value: true
            } : {
                name: translateService ? translateService.instant("ADMINISTRATION.SURVEY_QUESTION.COMMON.EVALUATOR") : '-',
                value: false
            };
        this.optionQuestion = this.optionQuestion ??  false 
        this.textQuestion = this.textQuestion ??  false 
    }
    /*
        public mapToTable() {
            return {
                idQuestionTypePk: this.idQuestionTypePk,
                isOptionQuestion: this.isOptionQuestion,
                isTextQuestion: this.isTextQuestion,
                txtQuestion: this.txtQuestion,
                typeQuestion: this.typeQuestion
            }
        }
    */
    public mapToBack() {
        return {
            txtQuestion: this.txtQuestion,
            optionQuestion: this.optionQuestion,
            textQuestion: this.textQuestion
        }
    }

    public mapToBackSurveyQuestion() {
        return {
            idQuestionTypePk: this.idQuestionTypePk,
            nmrOrder: this.nmrOrder,
            optionQuestion: _.get(this.typeQuestion,'value'),
            textQuestion: this.textQuestion,
            txtQuestion: this.txtQuestion,
            isQuestionEvaluated: _.get(this.isQuestionEvaluatedMapped,'value')
        }
    }
}